import { array } from "prop-types";

const propTypes = { draftReport: array };

const ReportBuilderIcon = (props) => {
  const { draftReport } = props;

  return (
    <div className="report-builder-icon">
      <a
        className="report-builder-icon__link"
        href="/report-builder"
        aria-label="Report Builder"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 21.23 24.92"
          width="38px"
          height="30px"
        >
          <g>
            <path
              d="M20.23 1H5.62v4.46h10.15v14.45h4.46z"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              d="M1 5.62h14.62v18.31H1z"
            />
            <g fill="currentColor">
              <path d="M4.62 10.15H12V12H4.62zM4.62 13.85H12v1.85H4.62zM4.62 17.54H12v1.85H4.62z" />
            </g>
          </g>
        </svg>
        {draftReport.length !== 0 && (
          <div className="report-builder-icon__badge">{draftReport.length}</div>
        )}
      </a>
    </div>
  );
};

ReportBuilderIcon.propTypes = propTypes;
export default ReportBuilderIcon;
